import appStyles from "@App/app.module.scss";

const unlockBody = () => {
  document?.body?.classList?.remove(appStyles.bodyLocked);
  const html = document?.getElementsByTagName("html");
  html?.[0]?.classList.remove(appStyles.bodyLocked);

  // Force Safari iOS to repaint after removing body lock.
  // Without this, Safari may not repaint the page after removing overflow:hidden
  // and touch-action:none, causing a white/blank screen until the user touches.
  // We use a non-visual forced reflow (offsetHeight read) instead of applying
  // transform to the body, which caused visible flicker on close animations.
  if (document?.body) {
    // eslint-disable-next-line no-unused-expressions
    document.body.offsetHeight;
  }
};

export default unlockBody;
